import { DEFAULT_LAYOUT } from '../base';
import { type AppRouteRecordRaw } from '../types';
import { IconUser } from "@arco-design/web-vue/es/icon";


const routes: AppRouteRecordRaw = {
  path: '/user-details',
  redirect: '/user-details/user-info',
  component: DEFAULT_LAYOUT,
  meta: {
    title: '用户信息',
    icon: IconUser,
    // hideChildrenInMenu: true,
    order: 800,
    roles: ['unauthorized-org-admin', 'unauthorized-org-user', 'authorized-org-admin', 'authorized-org-user', 'admin'],
    // roles: ['member'],
  },
  children: [
    {
      path: 'user-info/:id?',
      component: () => import('@/views/user-details/user-info.vue'),
      props: true,
      meta: {
        // hideInMenu: true,
        title: '个人信息',
        // roles: ['unauthorized-org-admin', 'unauthorized-org-user'],
      },
    },
    {
      path: 'user-history',
      component: () => import('@/views/user-details/user-history.vue'),
      props: true,
      meta: {
        ignoreCache: true,
        // hideInMenu: true,
        title: '个人历史评价',
      },
    },
  ],
};

export default routes;




